import { Fragment, useEffect, useState } from "react";

export const SpecificationContainer = ({ params }) => {
  const [specification, setSpecification] = useState(null);

  useEffect(() => {
    if (params && params.specification && params.specification != "") {
      setSpecification(params.specification);
    } else {
      setSpecification(null);
    }
  }, [params]);

  return (
    <Fragment>
      {specification && (
        <div className="productSpecification mt-4">
          {/* Title */}
          <div className="proSection-title featuresListing-right">
            <h4>Specifications</h4>
          </div>
          <div className="prosection-description">
            <p className="productPage-content" dangerouslySetInnerHTML={{ __html: specification }} />
          </div>
        </div>
      )}
    </Fragment>
  );
};
